import "../../index22.css";
import { jsx as m } from "react/jsx-runtime";
import { _ as a } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const _ = "_description_ytuey_1", c = "_with-centered-content_ytuey_4", S = "_text-size-extra-small_ytuey_10", d = "_text-size-small_ytuey_14", h = "_text-size-medium_ytuey_18", z = "_text-size-large_ytuey_22", y = "_with-light-text_ytuey_26", t = {
  description: _,
  withCenteredContent: c,
  textSizeExtraSmall: S,
  textSizeSmall: d,
  textSizeMedium: h,
  textSizeLarge: z,
  withLightText: y
};
function C(i) {
  const {
    className: n,
    children: s,
    withCenteredContent: r,
    elementRef: o,
    textSize: e = "md",
    withLightText: x,
    ...l
  } = i;
  return /* @__PURE__ */ m(
    "div",
    {
      ...l,
      ref: o,
      className: a(
        t.description,
        r && t.withCenteredContent,
        e === "xs" && t.textSizeExtraSmall,
        e === "sm" && t.textSizeSmall,
        e === "md" && t.textSizeMedium,
        e === "lg" && t.textSizeLarge,
        x && t.withLightText,
        n
      ),
      children: s
    }
  );
}
export {
  C as default
};
